const l = {
  name: "Uplift",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg>
        <path d="M20 4H15V2H22V9H20V4Z" fill="currentColor"/>
        <path d="M20 11V22H22V11H20Z" fill="currentColor"/>
        <path d="M16 22V15H18V22H16Z" fill="currentColor"/>
        <path d="M12 22V19H14V22H12Z" fill="currentColor"/>
        <path d="M11 8H16V13H18V6H11V8Z" fill="currentColor"/>
        <path d="M10.5896 12H7V10H14V17H12V13.418L3.38589 22.0321L1.97168 20.6179L10.5896 12Z" fill="currentColor"/>
    </svg>
  `
};
export {
  l as Uplift
};
